import React from 'react';
import { useHistory } from "react-router-dom";
import { Itemset } from "../../../store/viewmodels/ItemsetViewModel";
import { Item } from "../../../store/viewmodels/ItemViewModel";
import { Task } from "../../../store/viewmodels/TaskViewModel";
import { ItemsetResult } from '../../../store/viewmodels/ItemsetViewModel';
import { getNextUrl, postCheck } from "../../../utils/TaskNavigationServices";
import { getElementsByFiles, getFileElement } from "../../../utils/TaskContentServices";
import { addAnswerToSet, addItemSet, addStudentId, postAnswerSet, setStartTime, setEndTime, resetAsSliceState } from "../../../store/AnswerSetSlice";
import { useAppDispatch, useAppSelector } from "../../../store/Hooks";
import { StudentData } from '../../../store/viewmodels/StudentViewModel';
import { Answer } from "../../../store/viewmodels/AnswerViewModel";
import ModalWrapper from '../../utils/modal/ModalWrapper';
import FeedBack from './FeedBack';
import { shuffle } from "../../../utils/ItemServices";
import Header from './Header';

export interface StudentOneChoiceItemProps {
    task: Task,
    itemset: Itemset,
    item: Item
}

function StudentOneChoiceItem(props: StudentOneChoiceItemProps) {
    const dispatch = useAppDispatch();
    const studentData: StudentData = useAppSelector(state => state.studentData);
    let aStartTime = new Date();
    const history = useHistory();

    const [isModalVisible, setModalVisible] = React.useState(false);
    const [content, setContent] = React.useState(<></>);
    const [shuffledItems] = React.useState(shuffle(props.item.child_items) as Item[]);
    const showModal = () => {
        return;
    }

    const [selected, setSelected] = React.useState(undefined as Item | undefined);
    const [forward, setForward] = React.useState(false);
    const [clear, setClear] = React.useState(false);

    let nextUrl = getNextUrl(props.itemset, props.item, props.task, studentData.student.active_item_sets);

    React.useEffect(() => {
        const itemset: ItemsetResult = { id: props.itemset.id, name: props.itemset.name, type: props.itemset.type }
        dispatch(addStudentId(studentData.student.id));
        dispatch(addItemSet(itemset));
        let asStartTime = new Date();
        dispatch(setStartTime(asStartTime.toISOString()));

        setSelected(undefined);
        setForward(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if (clear) {
            setForward(false);
            setSelected(undefined);
            setClear(false);
        }
    }, [clear])

    const onChoiceClick = (item: Item) => {
        setSelected(item);
    }

    React.useEffect(() => {
        if (selected !== undefined) {
            setForward(true);
        } else {
            setForward(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected])

    const commitAnswer = () => {
        let correct = props.item.correct;
        let answerV = selected ? selected.content : "";

        let noFeedBack = props.task.no_feedback;
        let time = noFeedBack ? 0 : 1500;

        if (!noFeedBack) {
            let feedBack = answerV === correct ? <FeedBack key={"feedback_correct_" + props.item.id} correct={true} itemId={props.item.id} /> : <FeedBack key={"feedback_wrong_" + props.item.id} correct={false} itemId={props.item.id} />;
            setContent(feedBack);
            setModalVisible(true);
        }

        setTimeout(() => {
            setModalVisible(false);
            let answer: Answer = {} as Answer;
            let aEndTime = new Date();
            answer.item = props.item.id;
            answer.value = selected ? selected.content : "";
            answer.end_time = aEndTime.toISOString();
            answer.start_time = aStartTime.toISOString();
            dispatch(addAnswerToSet(answer));
            const postAnswerSetCheck: boolean = postCheck(props.itemset, props.item, props.task, studentData.student.active_item_sets);
            if (postAnswerSetCheck) {
                let asEndTime = new Date();
                dispatch(setEndTime(asEndTime.toISOString()));
                dispatch(postAnswerSet())
                    .then(() => {
                        dispatch(resetAsSliceState());
                    });
            }
            setSelected(undefined);
            setForward(false);
            setClear(clear!);
            history.push(nextUrl);
        }, time)
    }

    let choices = [] as JSX.Element[];
    for (let i: number = 0; i < shuffledItems.length; i++) {
        let item = shuffledItems[i];
        let file = item.files.length > 0 ? item.files?.[0] : undefined;
        let borderColor = selected?.id === item.id ? " ring-yellow-500" : " ring-teal-500 hover:text-teal-300";
        let checkColor = selected?.id === item.id ? " text-yellow-500" : " text-teal-500 hover:text-teal-300";

        let symbolSize = " absolute text-3xl lg:text-5xl 2xl:text-6xl 6xl:text-7xl 8xl:text-8xl 10xl:text-9xl "

        if (file !== undefined) {

            let fileElement = getFileElement(file);

            choices.push((
                <div key={item.id + item.name} className={"relative flex m-3 lg:m-4 xl:m-5 8xl:m-6 10xl:m-8" + borderColor} onClick={() => { onChoiceClick(item) }} >
                    <div className={"w-full h-full overflow-hidden ring-4 lg:ring-8 rounded-lg " + borderColor}>
                        <div className={"flex w-full h-full m-auto  "}>
                            {fileElement}
                        </div>
                    </div>
                    <div className={"z-50 absolute -top-4 -left-4 lg:-top-6 lg:-left-6 xl:-top-6 xl:-left-6 2xl:-top-7 2xl:-left-7 8xl:-left-9 8xl:-top-9 10xl:-left-14 10xl:-top-14"} onClick={() => { onChoiceClick(item) }}>
                        <div className="relative" >
                            <span className={" text-white ri-checkbox-blank-circle-fill" + symbolSize}></span>
                            <span className={checkColor + " ri-checkbox-circle-fill" + symbolSize}></span>
                        </div>
                    </div>
                </div >));
        }
    }

    let isQuestionElement = props.item.files.length > 0 ? true : false;
    let questionElement = isQuestionElement ? getElementsByFiles(props.item) : <></>;
    let cols = "grid-cols-2";

    switch (props.item.child_items.length) {
        case 1:
            {
                cols = "grid-cols-1";
                break;
            }
        case 2:
        case 3:
        case 4:
            {   
                cols = "grid-cols-2";
                break;
            }
        case 5:
        case 6: {
            cols = "grid-cols-3"
            break;
        }
        default: break;
    }

    let taskElement = isQuestionElement ? (
        <div className="flex justify-center w-full">
            <div className="max-w-1/2 6xl:max-w-2/5 m-auto">
                <div className="bg-teal-800 flex max-w-full h-auto overflow-hidden rounded-2xl ring-4 lg:ring-8 ring-gray-200 m-5">
                    {questionElement}
                </div>
            </div>
            <div className="flex m-auto max-w-1/2 6xl:max-w-2/5">
                <div className={"max-h-4/5 grid " + cols}>
                    {choices}
                </div>
            </div>
        </div>
    ) : (
        <div className="flex justify-center max-h-full max-w-full ">
            <div className="flex m-auto max-w-3/5 md:max-w-4/5 lg:max-w-4/5 2xl:max-w-2/3">
                <div className={"grid " + cols}>
                    {choices}
                </div>
            </div>
        </div>
    );

    return (
        <div className="h-fit w-fit">
            <ModalWrapper key={"ModalWindow_" + props.item.id} isVisible={isModalVisible} onBackdropClick={showModal} content={content} type={"feedBack"} />
            <div className=" h-5/6 justify-center my-auto">
                <div className="w-full h-5/6 flex justify-center my-auto">
                    {taskElement}
                </div>
                <div className="h-1/6">
                    <Header commitAnswer={commitAnswer} goForward={forward} type={"oneChoice"} setClear={setClear} />
                </div>
            </div>
        </div>
    );
}

export default StudentOneChoiceItem;
